/*
 * The Frosted Muzzle — care-pack donations (Phase 5 / Care Packs).
 *
 * Wires the dog-story tiles rendered by snippets/care-pack-donation-tile.liquid.
 * Each tile lets the customer pick a dose count, then adds ONE donation line
 * item: the donation product variant with quantity = dose count and the
 * line-item properties that mark it as a care-pack donation in the cart:
 *
 *   _donation: 'true'
 *   _dog_story_handle: <fm_dog_story handle>
 *   _system: <system handle the dog receives>
 *   _dose_count: <chosen dose count>
 *
 * It owns no analytics destinations — it dispatches `fm:analytics` events that
 * assets/analytics.js consumes (the `donation_added` event).
 */
(function () {
  'use strict';

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
  }

  function track(event, payload) {
    emit('fm:analytics', { event: event, payload: payload });
  }

  function initTile(tile) {
    var state = { dose: null };
    var variantId = tile.getAttribute('data-variant-id');
    var dogHandle = tile.getAttribute('data-dog-handle');
    var systemHandle = tile.getAttribute('data-system');
    var dogName = tile.getAttribute('data-dog-name') || '';
    var systemName = tile.getAttribute('data-system-name') || '';

    var doseButtons = Array.prototype.slice.call(tile.querySelectorAll('[data-fm-dose]'));
    var addButton = tile.querySelector('[data-fm-add]');
    var addLabel = tile.querySelector('[data-fm-add-label]');
    var errorEl = tile.querySelector('[data-fm-error]');

    function setLabel() {
      if (!addLabel) return;
      if (state.dose === null) {
        addLabel.textContent = addButton.getAttribute('data-fm-select-label') || addLabel.textContent;
      } else {
        var tmpl = addButton.getAttribute('data-fm-send-label') || 'Send [count] doses';
        addLabel.textContent = tmpl.replace('[count]', String(state.dose));
      }
    }

    doseButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.dose = parseInt(btn.getAttribute('data-fm-dose'), 10) || null;
        doseButtons.forEach(function (b) {
          b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
        });
        if (addButton) addButton.disabled = state.dose === null || !variantId;
        setLabel();
      });
    });

    if (!addButton) return;

    addButton.addEventListener('click', function () {
      if (state.dose === null || !variantId) return;
      addDonation();
    });

    async function addDonation() {
      var item = {
        id: variantId,
        quantity: state.dose,
        properties: {
          _donation: 'true',
          _dog_story_handle: dogHandle,
          _system: systemHandle,
          _dose_count: String(state.dose)
        }
      };
      // A human-readable label for the cart line (cart-side display).
      if (dogName) {
        item.properties._donation_for = dogName;
        item.properties._donation_label =
          'Donation — ' + (systemName || 'System') + ' for ' + dogName + ' (' + state.dose + ' doses)';
      }

      setLoading(true);
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      var cartDrawer = document.querySelector('cart-drawer');
      var sections =
        cartDrawer && cartDrawer.getSectionsToRender
          ? cartDrawer.getSectionsToRender().map(function (s) {
              return s.id;
            })
          : [];

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [item],
            sections: sections,
            sections_url: window.location.pathname
          })
        });
        var data = await res.json();
        if (!res.ok) throw new Error(data.description || 'cart add failed');

        track('donation_added', {
          dog_story_handle: dogHandle,
          system_handle: systemHandle,
          dose_count: state.dose
        });

        if (cartDrawer && data.sections) {
          if (cartDrawer.renderContents) cartDrawer.renderContents(data);
          cartDrawer.classList.remove('is-empty');
          if (cartDrawer.open) cartDrawer.open();
        }
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'fm-care-packs',
            productVariantId: variantId
          });
        }
      } catch (err) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = err.message;
        }
      } finally {
        setLoading(false);
      }
    }

    function setLoading(on) {
      addButton.classList.toggle('fm-care-tile__add--loading', on);
      addButton.setAttribute('aria-busy', on ? 'true' : 'false');
    }
  }

  function init() {
    document.querySelectorAll('[data-fm-donation-tile]').forEach(initTile);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
